module.exports = __webpack_public_path__ + "img/意大利站.550297ea.png";